export default __webpack_public_path__ + "static/media/socialVerification.62a7c097.svg";